export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="section-container">
        <div className="max-w-2xl mx-auto">
          <div className="bg-background-50 rounded-2xl p-8 md:p-10 border border-background-200/60 text-center">
            <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700 mb-3">
              联系投稿
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
              联系我们
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8 max-w-lg mx-auto">
              如果你发现了新的优质吃瓜爆料网站，或有任何建议和反馈，欢迎通过以下方式联系我们。推荐新站经审核通过后将收录至导航列表。
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
              <div className="p-4 rounded-xl bg-background-100 border border-background-200/60">
                <div className="w-10 h-10 rounded-lg bg-primary-50 flex items-center justify-center mx-auto mb-2">
                  <i className="ri-mail-line text-lg text-primary-600"></i>
                </div>
                <div className="text-xs font-medium text-foreground-900 mb-0.5">投稿邮箱</div>
                <div className="text-xs text-foreground-500 break-all">submit@chiguabaoliao.com</div>
              </div>
              <div className="p-4 rounded-xl bg-background-100 border border-background-200/60">
                <div className="w-10 h-10 rounded-lg bg-accent-50 flex items-center justify-center mx-auto mb-2">
                  <i className="ri-wechat-line text-lg text-accent-600"></i>
                </div>
                <div className="text-xs font-medium text-foreground-900 mb-0.5">微信公众号</div>
                <div className="text-xs text-foreground-500">吃瓜爆料网</div>
              </div>
              <div className="p-4 rounded-xl bg-background-100 border border-background-200/60">
                <div className="w-10 h-10 rounded-lg bg-secondary-50 flex items-center justify-center mx-auto mb-2">
                  <i className="ri-chat-smile-2-line text-lg text-secondary-600"></i>
                </div>
                <div className="text-xs font-medium text-foreground-900 mb-0.5">商务合作</div>
                <div className="text-xs text-foreground-500 break-all">bd@chiguabaoliao.com</div>
              </div>
            </div>

            <a
              href="#index"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-send-plane-line"></i>
              去推荐新网站
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}